"use client";

import { type JSX, useEffect } from "react";
import { type ApmBase, init as initApm } from "@elastic/apm-rum";
import { useSitecore } from "@sitecore-content-sdk/nextjs";
import { useConsent } from "lib/consent/useConsent";

let apm: ApmBase | null = null;

const ApmInitScript = (): JSX.Element | null => {
  const { page } = useSitecore();
  const isPageEditing = page.mode.isEditing;
  console.log("---->[ApmInitScript] Component", { isPageEditing });
  const hasConsent = useConsent("performance"); // C0002
  useEffect(() => {
    if (!isPageEditing && hasConsent && !apm) {
      apm = initApm({
        serviceName: process.env.NEXT_PUBLIC_APM_SERVICE_NAME || "",
        environment: process.env.NEXT_PUBLIC_APM_ENVIRONMENT || "",
        serverUrl: process.env.NEXT_PUBLIC_APM_SERVER_URL || "",
      });
    }
  }, [isPageEditing, hasConsent]);

  return <></>;
};

export default ApmInitScript;
